module.exports = __webpack_public_path__ + "37ba7b92/img/share-action-icon.9c12578c.svg";